import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import { Checkbox, ShowItemsSelect, Pagination, CouponModal } from '../utilites';
import { pageOptions } from '../../helpers/data-constants';
import { cashBoxService } from '../../services/cashbox-service';
import Loader from './Loader/Loader';

import './сashboxes.scss';
import '../../assets/styles/components/_tables.scss';

import PlusIcon from '../../assets/icons/plus-small.svg';
import { permissionsAccess } from "../../helpers/common";

const methods = {
  buildDataForSearch: (state) => {
    let data = {};
    data.size = state.pageRange;
    data.page = state.currentPage;
    data.sortBy = 'name';
    return data;
  },
};

const CashBoxes = () => {
  const [state, setState] = useState({
    currentPage: 1,
    total: 0,
    pageRange: pageOptions[0].value,
    showModalCouponBaseAdd: false,
    cashBoxes: [],
    loading: false,
    error: null,
    allChecked: false,
  });

  let checkedCashBoxes = state.cashBoxes
    .filter((cashBox) => cashBox.checked)
    .map((cashBox) => ({ id: cashBox.id, name: cashBox.name }));

  const searchCashBoxes = (data) => {
    setState((prev) => ({
      ...prev,
      loading: true,
      error: null,
    }));
    cashBoxService.getCashBoxes(data).then((response) => {
      setState((prev) => ({
        ...prev,
        cashBoxes: response.data.cashBoxes.map((c) => {
          c.checked = false;
          return c;
        }),
        total: response.data.totalElements,
        loading: false,
        allChecked: false
      }));
    });
  };

  useEffect(() => {
    let data = methods.buildDataForSearch(state);
    searchCashBoxes(data);
  }, [state.pageRange, state.currentPage]);

  const handleOnAllCashBoxCheck = () => {
    let cashBoxes = [...state.cashBoxes];
    let flag = state.allChecked;
    cashBoxes.forEach((cashBox) => {
      cashBox.checked = !flag;
    });
    setState((prev) => ({
      ...prev,
      cashBoxes: cashBoxes,
      allChecked: !flag,
    }));
  };

  const handleOnCashBoxCheck = (event) => {
    let cashBoxes = [...state.cashBoxes];
    cashBoxes.forEach((cashBox) => {
      if (cashBox.id === parseInt(event.target.id)) {
        cashBox.checked = event.target.checked;
      }
    });
    setState((prev) => ({ ...prev, cashBoxes }));
  };

  const onPageRangeChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    setState((prev) => ({
      ...prev,
      pageRange: parseInt(value),
      currentPage: 1,
    }));
  };

  const handlePageChange = (page) => {
    setState((prev) => ({
      ...prev,
      currentPage: page,
    }));
  };

  const changeModalState = (name, state) => {
    setState((prev) => ({
      ...prev,
      [name]: state,
    }));
  };

  const renderTableData = () => {
    return state.cashBoxes.map((cashBox) => {
      let address = `${cashBox.city ? ` ${cashBox.city},` : ''} ${cashBox.street}, ${
        cashBox.house
      }, ${cashBox.building ? 'к. ' + cashBox.building + ',' : ''} каб. ${cashBox.office}`;
      return (
        <tr key={cashBox.id} className={!cashBox.active ? 'disabled' : undefined}>
          <th scope="row">
            <span className="caption">Подразделение</span>
            <div className="table-cellcontent">
              <Checkbox
                label=""
                onChange={handleOnCashBoxCheck}
                id={cashBox.id}
                value={cashBox.checked}
                name="checkboxCashBox"
              />
              <p>
                <Link className="table-link" to={`/handbooks/department/${cashBox.id}`}>
                  <span>{cashBox.name}</span>
                </Link>
              </p>
            </div>
          </th>
          <td>
            <span className="caption">Телефон</span>
            <p>
              <a className="table-phone" href={`tel:+${cashBox.phone}`}>
                <span>{cashBox.phone}</span>
              </a>
            </p>
          </td>
          <td>
            <span className="caption">Адрес</span>
            <p>{address}</p>
          </td>
        </tr>
      );
    });
  };

  const closeCouponModal = () => changeModalState('showModalCouponBaseAdd', false);

  const openCouponModal = () => {
    if (checkedCashBoxes?.length > 0) {
      changeModalState('showModalCouponBaseAdd', true);
    }
  };

  return (
    <>
      <div className="content-inner-data-container">
        <div className="content-datatable">
          <div className="content-datatable-header sticky">
            <div className="content-datatable-header-actions d-flex">
              <div className="content-datatable-header-left">
                <div className="action-items ">
                  <button
                    className={
                      checkedCashBoxes?.length > 0 ? 'action-item' : 'disabled-action-item'
                    }
                    onClick={openCouponModal}>
                    Создать купон
                  </button>
                  {checkedCashBoxes?.length > 0 && state.showModalCouponBaseAdd && (
                    <CouponModal
                      cashBoxId={checkedCashBoxes}
                      flag={state.showModalCouponBaseAdd}
                      close={closeCouponModal}
                      onSuccess={undefined}
                    />
                  )}
                </div>
              </div>
              <div className="content-datatable-header-right">
                <div className="action-items">
                  <ShowItemsSelect options={pageOptions} change={onPageRangeChange} />
                </div>
                <div className="action-items">
                  {permissionsAccess("action.cashbox.create") &&
                      <Link
                      className="button-icontrigger-accent caption hover"
                      to="/handbooks/department">
                    <span className="icon">
                      <PlusIcon />
                    </span>
                    <span>Создать подразделение</span>
                  </Link>}
                </div>
              </div>
            </div>
          </div>
          <div className="content-datatable-content">
            {state.loading ? (
              <Loader pageRange={state.pageRange} />
            ) : (
              <table className="table hover" id="departments">
                <thead>
                  <tr>
                    <th scope="col">
                      <Checkbox
                        label="Подразделение"
                        onChange={permissionsAccess("action.cashbox.details") && handleOnAllCashBoxCheck}
                        id="checkboxCashBoxAll"
                        value={state.allChecked}
                        name="checkboxCashBoxAll"
                      />
                    </th>
                    <th scope="col">Телефон</th>
                    <th scope="col">Адрес</th>
                  </tr>
                </thead>
                <tbody>{renderTableData()}</tbody>
              </table>
            )}
          </div>
        </div>
      </div>
      <Pagination
        total={Math.ceil(state.total / state.pageRange)}
        current={state.currentPage}
        handlePageChange={handlePageChange}
      />
    </>
  );
};

export default CashBoxes;
